import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { WHATSAPP_LINK } from "@/lib/site";

export const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <motion.header
            data-testid="navbar"
            initial={{ y: -60, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6 }}
            className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
                scrolled
                    ? "backdrop-blur-xl bg-[#0A0A0F]/70 border-b border-white/5"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-6xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
                <a
                    href="#top"
                    data-testid="navbar-brand"
                    className="font-display font-extrabold tracking-tight text-[#F5F5F5] text-lg"
                >
                    DEGASPERIN<span className="text-[#3B6FFF]"> IA</span>
                </a>
                <nav className="hidden md:flex items-center gap-8 text-sm text-[#F5F5F5]/70 font-medium">
                    <a href="#produtos" className="hover:text-white transition-colors">
                        Produtos
                    </a>
                    <a href="#como-funciona" className="hover:text-white transition-colors">
                        Como funciona
                    </a>
                    <a href="#precos" className="hover:text-white transition-colors">
                        Investimento
                    </a>
                    <a href="#faq" className="hover:text-white transition-colors">
                        FAQ
                    </a>
                </nav>
                <a
                    data-testid="navbar-cta"
                    href={WHATSAPP_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="rounded-full bg-[#3B6FFF] px-5 py-2 text-sm font-semibold text-white hover:bg-[#2d5be0] transition-colors"
                >
                    Falar comigo
                </a>
            </div>
        </motion.header>
    );
};

export default Navbar;
